import _Event from "../playmore/event"

class Event extends _Event {
  constructor() {
    super()
    this.preventFocus = true
  }
  _init = async () => {
    document.addEventListener("keydown", e => e.detail === 26 && __.device.power === "on" && _$.handler.emit("powerEvent", { state: "STANDBY" }))
    return super._init()
  }

  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }
    /* Platform-specific Event */
    if (event.type === "platformEvent") {
      if (this.preventFocus) return false

      if (event.detail.state === "focused") _event.name = "applicationFocusing"
      else _event.name = "applicationUnfocused"

      if (_event.name === "applicationFocusing" && __.platform.focus) return false
      else if (_event.name === "applicationUnfocused" && !__.platform.focus) return false
      else if (_event.name === "applicationFocusing") {
        if (__.source.current !== "NONE") _$.handler.emit("sourceEvent", { state: "NONE" })
        await _$.sleep(1000)
        __._device.registerKeys()
      }
    } else if (event.type === "mediaEvent") {
      let tempName
      switch (event.detail.state) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        case "paused":
          tempName = "mediaPaused"
          break
        case "encounteredError":
          tempName = "mediaError"
          break
        default:
          return false
      }
      _event.name = tempName
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "powerEvent") {
      _event.name = "power"
      _event.data = event.detail.state.toLowerCase()
      if (_event.data === "on") _$.sleep(5000).then(() => (this.preventFocus = false))
    } else if (event.type === "sourceEvent") {
      _event.name = "source"
      _event.data = event.detail.state
      if (playmore.platform.isAppForeground()) _event.data = "NONE"
      if (event.detail.state === "COMBINED_CHANNEL_SOURCE") _event.data = "NONE"
      if (event.detail.state === "NONE") await _$.sleep(1000)
    } else if (event.type === "messageEvent") {
      let socketData = null
      try {
        socketData = window.atob(event.detail.state)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
}

export default Event
